import React, { useState } from 'react'
import Shadeddiv from '../Components/Shadeddiv'
import {BsFillTelephoneFill} from 'react-icons/bs'
import {BiLogoGmail} from 'react-icons/bi'
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";

const Contact = () => {
  const[formmess,setformmess]=useState("");
  // const [btntxt,setbtntxt]=useState("Send message");
  function handlemesschange(event){
      setformmess(event.target.value); 
  }
  


  return (
    <>
     <div className='bg-whatbg w-screen relative min-h-screen h-max flex flex-col  justify-evenly items-center gap-10' id='Contact'>
        {/*shaded div  */}
        <Shadeddiv shadedtext={"Contact me"} underlinetext1={"Get"} underlinetext2={" In "} underlinetext3={"Touch"}/>
        
        {/* main div */}
        <div className='w-3/4 ml-56  flex gap-5 lg:ml-0 mb-4 md:flex-wrap-reverse'>
          {/* address */}
          <div className='flex flex-col gap-6  p-3  w-[280px]'>
            <div className='text-white text-3xl uppercase flex flex-col'>Address</div>
            <div className='text-white capitalize text-lg'>new shivpuri st no:1 ludhiana punjab india</div>
            <div className='flex items-center gap-x-3'>
              {/* phone icon */}
              <div className='text-red text-xl'>
                <BsFillTelephoneFill/>
              </div>
              <div className='text-white text-lg'>9915455831</div>
            </div>
            <div className='flex items-center gap-x-3 '>
              {/* mail icon */}
              <div className='text-red text-xl'>
              <BiLogoGmail/>
              </div>
              <div className='text-white text-lg'>hardikchopra70@gmail.com</div>
            </div>
            {/* follow me */}
            <div className='flex flex-col gap-y-5'>
             <div className='text-white uppercase text-xl font-semibold'>follow me</div> 
              {/* icons */}
              <div className='flex gap-4 text-lg'>
                <a href="https://www.instagram.com/hardiichopra/">
               <FaInstagram className='text-red cursor-pointer'/>
                </a>
                <a href="https://www.facebook.com/profile.php?id=100093304591176">
               <FaFacebookF className='text-blue-300 cursor-pointer'/>
                </a>
                <a href="https://www.linkedin.com/in/hardik-chopra-648b28233">
               <FaLinkedin className='text-blue-300 cursor-pointer'/> 
                </a>
              </div>
            </div>
          </div>
          {/* send message */}
          <div className='w-full'>
            <h5 className='text-white uppercase text-3xl text-center'>send us a note</h5>
            <div className='flex gap-4 w-full mt-5 sm:flex-wrap'>
            </div>
            <div className='mt-6 w-full   h-48  '>
            <textarea  name={formmess} onChange={handlemesschange} value={formmess} className='w-full py-3 h-full  text-white  bg-formcolorinput capitalize   px-4 rounded-md' placeholder='tell me more about your project needs....' />
            </div>
            <div className='w-full mt-2 mb-3 flex items-center justify-center '>
              <a href={`mailto:hardikchopra70@gmail.com?
              &subject=Regarding my project work 
              &body=${formmess}`}>
            <button className="capitalize w-48 h-14 block text-center text-white rounded-full border-2   
             border-red bg-red mt-5">Send Message</button>
             </a>
             </div>
          </div>
        </div>
    </div>
    </> 
)
}

export default Contact
